<template>
    <div style="min-width: 1800px">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <span class="page-title">ETP业务系统</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>数据概览</el-breadcrumb-item>
        </el-breadcrumb>

        <el-row :gutter="20" style="margin-top: 20px">
            <el-col :span="4">
                <div style="width: 250px;height: 120px;background-color: white;text-align: center;vertical-align: middle;display:table-cell;font-size: 16px">
                    <p>前一日管理费</p>
                    <span>{{beforeDayData.beforeDayManagement}}</span>&nbsp;&nbsp;<span>USDT</span>
                </div>
            </el-col>
            <el-col :span="4">
                <div style="width: 250px;height: 120px;background-color: white;text-align: center;vertical-align: middle;display:table-cell;font-size: 16px">
                    <p>前一日手续费</p>
                    <span>{{beforeDayData.beforeDayFee}}</span>&nbsp;&nbsp;<span>USDT</span>
                </div>
            </el-col>
            <el-col :span="4">
                <div style="width: 250px;height: 120px;background-color: white;text-align: center;vertical-align: middle;display:table-cell;font-size: 16px">
                    <p>前一日交易额</p>
                    <span>{{beforeDayData.beforeDayTurnover}}</span>&nbsp;&nbsp;<span>USDT</span>
                </div>
            </el-col>
            <el-col :span="4">
                <div style="width: 250px;height: 120px;background-color: white;text-align: center;vertical-align: middle;display:table-cell;font-size: 16px">
                    <p>前一日交易人数</p>
                    <span>{{beforeDayData.beforeDayTradeNumber}}</span>
                </div>
            </el-col>
            <el-col :span="4">
                <div style="width: 250px;height: 120px;background-color: white;text-align: center;vertical-align: middle;display:table-cell;font-size: 16px">
                    <p>前一日持仓量</p>
                    <span>{{beforeDayData.beforeDayHoldAmount}}</span>&nbsp;&nbsp;<span>USDT</span>
                </div>
            </el-col>
        </el-row>

        <el-row :gutter="20" style="margin-top: 20px">
            <el-col :span="10">
                <div id="manage-free" style="width: 100%;height: 350px"></div>
            </el-col>
            <el-col :span="10">
                <div id="service-free" style="width: 100%;height: 350px"></div>
            </el-col>
        </el-row>

        <el-row :gutter="20" style="margin-top: 20px">
            <el-col :span="10">
                <el-row :gutter="20">
                    <el-col :span="10">
                        <div id="capital-ratio" style="width: 100%;height: 450px"></div>
                    </el-col>
                    <el-col :span="10">
                        <div id="people-ratio" style="width: 100%;height: 450px"></div>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :span="10">
                <div id="people-top" style="width: 100%;height: 450px"></div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import './store';
    import api from './api';
    import moment from 'moment';

    export default {
        name: 'DataOverview',
        data() {
            return {
                manageFreeOption: null,
                manageFreeChart: null,
                serviceFreeOption: null,
                serviceFreeChart: null,
                capitalRatioOption: null,
                capitalRatioChart: null,
                peopleRatioOption: null,
                peopleRatioChart: null,
                peopleTopOption: null,
                peopleTopChart: null,
                beforeDayData: {},
                DEFAULT_FORMAT: 'YYYY-MM-DD'
            };
        },
        methods: {
            moment(value) {
                if (!value) return '';
                return moment(value).format(this.DEFAULT_FORMAT);
            },
            getBeforeDayData() {
                api.getBeforeDayData().then(({data}) => {
                    this.beforeDayData = data;
                });
            },
            getStatistics() {
                api.getStatistics().then(({data}) => {
                    this.initManageFree(data);
                    this.initServiceFree(data);
                });
            },
            getHoldInfo() {
                api.getHoldInfo().then(({data}) => {
                    this.initCapitalRatio(data);
                    this.initPeopleRatio(data);
                });
            },
            getHoldTop() {
                api.getHoldTop().then(({data}) => {
                    this.initPeopleTop(data);
                });
            },
            initManageFree(data) {
                let _othis = this;
                let manageFree = document.getElementById('manage-free');
                this.manageFreeChart = this.$echarts.init(manageFree);
                this.manageFreeOption = {
                    title: {
                        text: '每日管理费走势'
                    },
                    tooltip: {
                        show: true,
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross'
                        },
                        formatter: function (params) {
                            return "时间：" + _othis.moment(params[0].axisValue) + "<br>" + "管理费：" + params[0].value + " USDT";
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data: []
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        data: [],
                        type: 'line'
                    }]
                };

                if (data && data.statisticsManagementList) {
                    for (let i = 0; i < data.statisticsManagementList.length; i++) {
                        this.manageFreeOption.xAxis.data.push(this.moment(data.statisticsManagementList[i].time));
                        this.manageFreeOption.series[0].data.push(data.statisticsManagementList[i].amount);
                    }
                }

                this.manageFreeOption && this.manageFreeChart.setOption(this.manageFreeOption);
            },
            initServiceFree(data) {
                let _othis = this;
                let serviceFree = document.getElementById('service-free');
                this.serviceFreeChart = this.$echarts.init(serviceFree);
                this.serviceFreeOption = {
                    title: {
                        text: '每日手续费走势'
                    },
                    tooltip: {
                        show: true,
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross'
                        },
                        formatter: function (params) {
                            return "时间：" + _othis.moment(params[0].axisValue) + "<br>" + "手续费：" + params[0].value + " USDT";
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data: []
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        data: [],
                        type: 'line'
                    }]
                };

                if (data && data.statisticsFeeList) {
                    for (let i = 0; i < data.statisticsFeeList.length; i++) {
                        this.serviceFreeOption.xAxis.data.push(this.moment(data.statisticsFeeList[i].time));
                        this.serviceFreeOption.series[0].data.push(data.statisticsFeeList[i].amount);
                    }
                }

                this.serviceFreeOption && this.serviceFreeChart.setOption(this.serviceFreeOption);
            },
            initCapitalRatio(data) {
                let capitalRatio = document.getElementById('capital-ratio');
                this.capitalRatioChart = this.$echarts.init(capitalRatio);
                this.capitalRatioOption = {
                    title: {
                        text: '持仓资金量多空比'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: function (params) {
                            return params.name + " " + params.percent + "%";
                        }
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: '60%',
                            data: [
                                {value: data.holdAmountRateLong != null ? data.holdAmountRateLong : 0, name: '多'},
                                {value: data.holdAmountRateShort != null ? data.holdAmountRateShort : 0, name: '空'},
                            ],
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 2,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                };

                this.capitalRatioOption && this.capitalRatioChart.setOption(this.capitalRatioOption);
            },
            initPeopleRatio(data) {
                let peopleRatio = document.getElementById('people-ratio');
                this.peopleRatioChart = this.$echarts.init(peopleRatio);
                this.peopleRatioOption = {
                    title: {
                        text: '持仓人数多空比'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: function (params) {
                            return params.name + " " + params.percent + "%";
                        }
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: '60%',
                            data: [
                                {value: data.holdNumberRateLong != null ? data.holdNumberRateLong : 0, name: '多'},
                                {value: data.holdNumberRateShort != null ? data.holdNumberRateShort : 0, name: '空'},
                            ],
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 2,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                };

                this.peopleRatioOption && this.peopleRatioChart.setOption(this.peopleRatioOption);
            },
            initPeopleTop(data) {
                let peopleTop = document.getElementById('people-top');
                this.peopleTopChart = this.$echarts.init(peopleTop);
                this.peopleTopOption = {
                    title: {
                        text: "持仓人数TOP10币种"
                    },
                    dataset: {
                        source: [
                            ['amount', 'coin']
                        ]
                    },
                    grid: {containLabel: true},
                    xAxis: {name: '人数'},
                    yAxis: {type: 'category'},
                    series: [
                        {
                            type: 'bar',
                            barWidth: 13,
                            encode: {
                                x: 'amount',
                                y: 'coin'
                            },
                            itemStyle: {
                                normal: {
                                    label: {
                                        show: true,		//开启显示
                                        position: 'right',	//在上方显示
                                        textStyle: {	    //数值样式
                                            color: 'black',
                                            fontSize: 12
                                        }
                                    }
                                }
                            }
                        }
                    ]
                };

                if (data && data.userHoldTopList) {
                    for (let i = data.userHoldTopList.length - 1; i >= 0; i--) {
                        this.peopleTopOption.dataset.source.push([data.userHoldTopList[i].holdNumber, data.userHoldTopList[i].coinBelong]);
                    }
                }

                this.peopleTopOption && this.peopleTopChart.setOption(this.peopleTopOption);
            },
        },
        created() {
        },
        mounted() {
            this.getBeforeDayData();
            this.getStatistics();
            this.getHoldInfo();
            this.getHoldTop();
        }
    };
</script>

<style lang="less" scoped></style>

